export default __webpack_public_path__ + "static/media/imgLoja02.71010587.png";